// extracted by mini-css-extract-plugin
export default {"media-formats":"media-formats--a0HKbwiZOZ","mediaFormats":"media-formats--a0HKbwiZOZ"};